import { Timing } from "../../engine/effects/effect";
import type { Sound } from "../../engine/things/sounds/sound";

export type SoundBucket = "pre" | "pos" | "immediate";

/**
 * Decides a Sound's playback bucket at turn-effects load time. Default-timing
 * non-looping sounds bucket into `pre` so reaction sounds (mob attacks, hits)
 * sync with default-order visuals; looping ambients stay immediate so they
 * aren't gated on an unrelated animation pipeline.
 */
export function routeSoundBucket(sound: Sound): SoundBucket {
	const timing = sound.getTiming();
	if (timing === Timing.BEFORE_STATE_UPDATE) return "pre";
	if (timing === Timing.AFTER_STATE_UPDATE) return "pos";
	if (sound.loop) return "immediate";
	return "pre";
}
